import React, { useState, useEffect } from "react";
import { service } from "../../../services/AxiosServices";
import { useParams, useNavigate } from "react-router-dom";
import SectionHeader from "../molecules/SectionHeader";
import TitlesDetailsList from "../molecules/TilesDetailsList";
import MainLayout from "../../Layouts/MainLayout";
import { Navigate } from "react-router-dom";
import { useCrewAuth } from "../../../context/CrewAndSpaceContext";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import Spinner from "../atoms/Spinner";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
// Fetches and displays either crew or space data based on the category parameter, 
// with permissions for adding or deleting entries.

interface CrewProps {
  id: number;
  crew_name: string;
  crew_description: string;
  phase?:number
}
interface SpaceProps {
  id: number;
  space_name: string;
  space_description: string;
  phase?:number
}

interface Type {
  id: number;
  title: string;
  description: string;
}

const TilesDetailsPage: React.FC = () => {
  const { category } = useParams<{ category: string }>();
  // const [crews, setCrews] = useState<Type[]>([]);
  // const [spaces,setSpaces] = useState<Type[]>([])
  const { crews, spaces, setCrews, setSpaces, deleteCrew, deleteSpace } =
    useCrewAuth()!;
  const [loading, setLoading] = useState<boolean>(false);
  const accessCheckLoading = useAccessCheckLoading();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        if (category === "crews") {
          const crewResponse = await service<{ crews: CrewProps[] }>(
            "api/get-all-crew",
            "post",
            { project_id: localStorage.getItem("project_id") }
          );

          setCrews(
            crewResponse?.data?.crews?.map((crew: CrewProps) => ({
              id: crew?.id,
              title: crew?.crew_name || `Crew ${crew.id}`,
              description: crew?.crew_description || "No description available",
              phase:crew?.phase
            })) || []
          );
        } else if (category === "knowledge-hubs") {
          const spaceResponse = await service<{ response: SpaceProps[] }>(
            "api/get-spaces",
            "post",
            { project_id: localStorage.getItem("project_id") }
          );

          setSpaces(
            spaceResponse?.data?.response?.map((space: SpaceProps) => ({
              id: space?.id,
              title: space?.space_name || `Space ${space.id}`,

              description:
                space?.space_description || "No description available",
                phase:space.phase
            }))
          );
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [category, setCrews, setSpaces]);

  const validCategories = ["knowledge-hubs", "crews", "ai-training"];

  if (!validCategories.includes(category || "")) {
    return <Navigate to="*" replace />;
  }

  const data = {
    // 'knowledge-hubs': [
    //   { id: 1, title: 'Space-1', description: 'Description for Space-1' },
    //   { id: 2, title: 'Space-2', description: 'Description for Space-2' },
    //   { id: 3, title: 'Space-3', description: 'Description for Space-3' },
    //   { id: 4, title: 'Space-4', description: 'Description for Space-4' },
    // ],
    "knowledge-hubs": spaces.length > 0 ? spaces : [],
    crews: crews.length > 0 ? crews : [],
    // 'crews':[
    //   { id: 1, title: 'Crew-1', description: 'Description for Crew-1' },
    //   { id: 2, title: 'Crew-2', description: 'Description for Crew-2' },
    //   { id: 3, title: 'Crew-3', description: 'Description for Crew-3' },
    //   { id: 4, title: 'Crew-4', description: 'Description for Crew-4' },
    // ],
    "ai-training": [
      {
        id: 1,
        title: "AI-Training-1",
        description: "Description for AI-Training-1",
      },
      {
        id: 2,
        title: "AI-Training-2",
        description: "Description for AI-Training-2",
      },
      {
        id: 3,
        title: "AI-Training-3",
        description: "Description for AI-Training-3",
      },
      {
        id: 4,
        title: "AI-Training-4",
        description: "Description for AI-Training-4",
      },
    ],
  };

  const tiles = category
    ? data[category as keyof typeof data] || []
    : Object.values(data).flat();

  const handleAdd = () => {
    if (category === "knowledge-hubs") {
      navigate("/add_space");
    } else if (category === "crews") {
      navigate("/add_crew");
    }
  };

  const handleDelete = (id: number) => {
    if (category === "knowledge-hubs") {
      // setSpaces((prev) => prev.filter((space) => space.id !== id));
      deleteSpace(id);
    } else {
      // setCrews((prev) => prev.filter((crew) => crew.id !== id));
      deleteCrew(id);
    }
  };

  // return (
  //   <MainLayout>
  //     <AccessControl
  //       requiredPermissions={[{ permission: "create_crew", types: ["read"] }]}
  //       renderNoAccess={<AccessDenied />}
  //     >
  //       <SectionHeader
  //         title={category ? `My ${category.replace("-", " ")}` : "Details"}
  //         onAdd={handleAdd}
  //         action="Create"
  //         link={category === "knowledge-hubs" ? "/add_space" : "/add_crew"}
  //       />

  //       <TitlesDetailsList
  //         tiles={tiles}
  //         category={category || ""}
  //         loading={loading}
  //         onDelete={handleDelete}
  //       />
  //     </AccessControl>
  //   </MainLayout>
  // );

  return (
    <MainLayout>

        <AccessControl
          requiredPermissions={[{ permission:  category === "crews" ? "create_crew" : "knowledge_hub", types: ["read"] }]}
          renderNoAccess={accessCheckLoading ? <Spinner /> : <AccessDenied />}
        >
          <SectionHeader
           back ={true}
            title={category ==="crews" ? `My agentic ${category.replace("-", " ")}` :  category === "knowledge-hubs"?`My ${category.replace("-", " ")}`:""}
            onAdd={handleAdd}
            action="Create"
            link="/add_crew"
            permissionName={
             category === "crews" ? "create_crew" :"manage_spaces"
            }
            permissionTypes={['create']}
          />

          <TitlesDetailsList
            tiles={tiles}
            category={category || ""}
            loading={loading}
            onDelete={handleDelete}
          />
        </AccessControl>
     
       
    </MainLayout>
  );
};

export default TilesDetailsPage;
